const root = "Tag-module_root_cJ2O-lnU";
const styles = {
  root
};
export {
  styles as default,
  root
};
